<div class="min-h-screen w-full flex flex-col relative overflow-x-hidden overflow-y-visible text-white">
    <app-header (showMenu)=" scroll(true); show = true;"></app-header>
    <main class="flex-1 bg-black font-inter">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-side-menu *ngIf="show" (closeMenu)="scroll(false); show = false;"></app-side-menu>
</div>